import $ from 'jquery';
window.jQuery = $;

(function (jQuery, window) {
    if (!jQuery) {
        return;
    }

    // ----- Cookie helper (from original library) -----
    if (typeof jQuery.cookie !== 'function') {
        jQuery.cookie = function (key, value, options) {
            if (typeof value !== 'undefined') {
                options = options || {};
                if (value === null) {
                    value = '';
                    options.expires = -1;
                }
                let expires = '';
                if (options.expires && (typeof options.expires === 'number' || options.expires.toUTCString)) {
                    let date;
                    if (typeof options.expires === 'number') {
                        date = new Date();
                        date.setTime(date.getTime() + (options.expires * 24 * 60 * 60 * 1000));
                    } else {
                        date = options.expires;
                    }
                    expires = '; expires=' + date.toUTCString();
                }
                const path = options.path ? '; path=' + (options.path) : '';
                const domain = options.domain ? '; domain=' + (options.domain) : '';
                const secure = options.secure ? '; secure' : '';
                document.cookie = [key, '=', encodeURIComponent(value), expires, path, domain, secure].join('');
            } else {
                let cookieValue = null;
                if (document.cookie && document.cookie !== '') {
                    const cookies = document.cookie.split(';');
                    for (let i = 0; i < cookies.length; i++) {
                        const cookie = jQuery.trim(cookies[i]);
                        if (cookie.substring(0, key.length + 1) === (key + '=')) {
                            cookieValue = decodeURIComponent(cookie.substring(key.length + 1));
                            break;
                        }
                    }
                }
                return cookieValue;
            }
        };
    }

    const Shopify = window.Shopify = window.Shopify || {};

    const defaults = {
        howManyToShow: 3,
        howManyToStoreInMemory: 10
    };

    const storage = {
        configuration: {
            expires: 90,
            path: '/',
            domain: window.location.hostname
        },
        name: 'shopify_recently_viewed',
        write(handles) {
            jQuery.cookie(this.name, handles.join(' '), this.configuration);
        },
        read() {
            const cookie = jQuery.cookie(this.name);
            if (!cookie) {
                return [];
            }
            return cookie.split(' ').filter(Boolean);
        },
        destroy() {
            jQuery.cookie(this.name, null, this.configuration);
        },
        remove(handle) {
            const handles = this.read();
            const index = jQuery.inArray(handle, handles);
            if (index !== -1) {
                handles.splice(index, 1);
                this.write(handles);
            }
        }
    };

    const normalizeImageSrc = (image) => {
        if (!image) {
            return '';
        }
        if (typeof image === 'string') {
            return image;
        }
        if (typeof image === 'object' && typeof image.src === 'string') {
            return image.src;
        }
        return '';
    };

    const resizeImage = (src, size) => {
        const source = normalizeImageSrc(src);

        if (!source) {
            return null;
        }

        const normalized = source.replace(/^https?:/, '');

        if (!size || size === 'master') {
            return normalized;
        }

        const match = normalized.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif|webp|avif)(\?[^#]+)?$/i);
        if (!match) {
            return normalized;
        }

        const prefix = normalized.slice(0, match.index);
        const suffix = match[0];

        return `${prefix}_${size}${suffix}`;
    };

    const fetchProductJSON = (handle) => {
        return new Promise((resolve, reject) => {
            jQuery.ajax({
                dataType: 'json',
                url: `/products/${handle}.js`,
                cache: false
            }).done(resolve).fail((err) => {
                storage.remove(handle);
                reject(err);
            });
        });
    };

    const getUniqueHandles = (handles) => {
        const unique = [];
        handles.forEach((handle) => {
            if (unique.indexOf(handle) === -1) {
                unique.push(handle);
            }
        });
        return unique;
    };

    const Products = {
        resizeImage,
        recordRecentlyViewed(options = {}) {
            const config = jQuery.extend({}, defaults, options);
            const handles = storage.read();

            if (window.location.pathname.indexOf('/products/') === -1) {
                return;
            }

            const match = window.location.pathname.match(/\/products\/([a-z0-9\-]+)/i);
            if (!match || !match[1]) {
                return;
            }

            const handle = match[1];
            const index = jQuery.inArray(handle, handles);

            if (index === -1) {
                handles.unshift(handle);
                handles.splice(config.howManyToStoreInMemory);
            } else {
                handles.splice(index, 1);
                handles.unshift(handle);
            }

            storage.write(handles);
        },
        getRecentlyViewedHandles() {
            return storage.read();
        },
        clearList() {
            storage.destroy();
        },
        fetchProduct(handle) {
            if (!handle) {
                return Promise.resolve(null);
            }
            return fetchProductJSON(handle).catch(() => null);
        },
        fetchProducts(handles = [], limit = defaults.howManyToShow) {
            const uniqueHandles = getUniqueHandles(handles);
            if (!uniqueHandles.length || !limit) {
                return Promise.resolve([]);
            }

            const target = Math.max(0, limit);
            const collected = [];

            const processNext = (index) => {
                if (collected.length >= target || index >= uniqueHandles.length) {
                    return Promise.resolve(collected);
                }

                const handle = uniqueHandles[index];
                return fetchProductJSON(handle)
                    .then((product) => {
                        if (product) {
                            collected.push(product);
                        }
                        return processNext(index + 1);
                    })
                    .catch(() => processNext(index + 1));
            };

            return processNext(0);
        }
    };

    Shopify.Products = Object.assign({}, Shopify.Products || {}, Products);

    if (typeof Shopify.money_format === 'undefined') {
        Shopify.money_format = '${{amount}}';
    }

    if (typeof Shopify.formatMoney !== 'function') {
        Shopify.formatMoney = function (cents, format) {
            if (typeof cents === 'string') {
                cents = cents.replace('.', '');
            }
            const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
            const formatString = format || this.money_format;

            function defaultOption(opt, def) {
                return (typeof opt === 'undefined' ? def : opt);
            }

            function formatWithDelimiters(number, precision, thousands, decimal) {
                precision = defaultOption(precision, 2);
                thousands = defaultOption(thousands, ',');
                decimal = defaultOption(decimal, '.');

                if (isNaN(number) || number == null) {
                    return 0;
                }

                number = (number / 100.0).toFixed(precision);

                const parts = number.split('.');
                const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
                const centsValue = parts[1] ? (decimal + parts[1]) : '';

                return dollars + centsValue;
            }

            let value = '';

            switch (formatString.match(placeholderRegex)[1]) {
                case 'amount':
                    value = formatWithDelimiters(cents, 2);
                    break;
                case 'amount_no_decimals':
                    value = formatWithDelimiters(cents, 0);
                    break;
                case 'amount_with_comma_separator':
                    value = formatWithDelimiters(cents, 2, '.', ',');
                    break;
                case 'amount_no_decimals_with_comma_separator':
                    value = formatWithDelimiters(cents, 0, '.', ',');
                    break;
            }

            return formatString.replace(placeholderRegex, value);
        };
    }
})(jQuery, window);
